import api from "./api";
import StorageService from "./StorageService";

const ProjectVehicleService = {
  // getAll: async () => {
  //   const response = await api.get("/projectVehicle/getAll");
  //   return response.data;
  // },

  getAll: async (page = 1, limit = 20, search = "", employeeId = null, roleId = null, companyId = null) => {
    const login = StorageService.loginData();
    const activeCompany = StorageService.activeCompany();
    const response = await api.get("/projectVehicle/getAll", {
      params: {
        pageNumber: page,
        noOfRows: limit,
        search,
        employeeId: employeeId || login?.employeeId,
        roleId: roleId || login?.roleId,
        companyId: companyId || activeCompany?.companyId,
      },
    });
    return response.data;
  },

  getActive: async () => {
    const response = await api.get("/projectVehicle/active");
    return response.data;
  },

  getById: async (id) => {
    const response = await api.get(`/projectVehicle/getById/${id}`);
    return response.data;
  },

  save: async (data) => {
    const response = await api.post("/projectVehicle/save", data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await api.put(`/projectVehicle/update/${id}`, data);
    return response.data;
  },

  updateStatus: async (id) => {
    const response = await api.put(`/projectVehicle/updateStatus/${id}`);
    return response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`/projectVehicle/${id}`);
    return response.data;
  },
};

export default ProjectVehicleService;
